import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Container, Typography, Box } from '@mui/material';
import axios from 'axios';
import { useAuth } from '../AuthContext'; // Import du contexte
import apiUrl from '../config';
import '../CSS/Login.css';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useLocation } from 'react-router-dom';



const LoginForm = () => {
  const [email, setEmail] = useState('');
  const [mot_de_passe, setMotDePasse] = useState('');
  const navigate = useNavigate();
  const { isAuthenticated, login } = useAuth();  // Récupérer isAuthenticated et login depuis le contexte
  const [notification, setNotification] = useState({ open: false, message: '', severity: 'success' });
  const [loadingLogin, setLoadingLogin] = useState(false);
  const location = useLocation();
  const from = location.state?.from?.pathname || "/";  // Récupère la page d'origine
  
  useEffect(() => {
    if (!loadingLogin && isAuthenticated) {
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, loadingLogin, navigate, from]);
  
  

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingLogin(true);  
  
    try {
      const res = await axios.post(`${apiUrl}/login`, { email, mot_de_passe });
  
      if (res.data.token) {
        login(res.data.role, res.data.token);  // ✅ Connexion dans le contexte (isAuthenticated va se mettre à jour)
      } else {
        throw new Error('Token absent dans la réponse');
      }
    } catch (error) {
      console.error('Login error:', error.response ? error.response.data : error.message);
      setNotification({
        open: true,
        message: 'Nom d’utilisateur ou mot de passe incorrect',
        severity: 'error',
      });
    } finally {
      setLoadingLogin(false);
    }
  };
  

  return (
    <Container maxWidth="sm" className="login-container">
      <div className="login-logo-container">
        <img src="/NOVA PORTAGE Main Logo.png" alt="Logo Nova Portage" className="login-logo" />
      </div>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom>
          Connexion
        </Typography>
        <form onSubmit={handleSubmit}>
          <TextField
            fullWidth
            label="Email"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <TextField
            fullWidth
            label="Mot de passe"
            type="password"
            margin="normal"
            value={mot_de_passe}
            onChange={(e) => setMotDePasse(e.target.value)}
            required
          />
          <Button type="submit" variant="contained" color="primary" fullWidth disabled={loadingLogin}>
            {loadingLogin ? 'Connexion en cours...' : 'Se connecter'}
          </Button>
        </form>
      </Box>
      <Snackbar
        open={notification.open}
        autoHideDuration={3000}
        onClose={() => setNotification({ ...notification, open: false })}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert severity={notification.severity} sx={{ width: '100%', fontWeight: 'bold', textAlign: 'center' }}>
          {notification.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default LoginForm;
